const type = 'advanced'
const path = 'client/html'
const name = 'app.js'
const fullPath = `${path}/${name}`

const conditions = [
  {
    option: 'backend',
    type: 'different',
    value: 'java',
  },
  {
    parameter: 'buttons',
    type: 'not_includes',
    value: 'payment-buttons_3ds',
  },
]

export { type, path, name, fullPath, conditions }
